__turbopack_context__.v({
  "control": "I2pCBq_control",
  "ecoSwitch": "I2pCBq_ecoSwitch",
  "heading": "I2pCBq_heading",
  "info": "I2pCBq_info",
  "subtext": "I2pCBq_subtext",
  "switch": "I2pCBq_switch",
  "switchSlot": "I2pCBq_switchSlot",
  "switchWrapper": "I2pCBq_switchWrapper",
});
